import React from 'react';
import { Content, Button, Text, Flex } from '@leverege/ui-elements';
import { LoadingScreen } from '@leverege/molten/screens';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
function Resetting(props) {
  const {
    vehiclesDeleted,
    vehicles,
    zonesDeleted,
    zones,
    cancel
  } = props;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Content.Area, {
      layout: "flex:col",
      variant: "dialogBody",
      children: /*#__PURE__*/_jsx(LoadingScreen, {
        title: /*#__PURE__*/_jsxs(Flex, {
          variant: "colM",
          children: [/*#__PURE__*/_jsx(Text, {
            variant: "subtitle",
            children: "Reset Pending"
          }), /*#__PURE__*/_jsxs(Flex, {
            variant: "colS",
            children: [/*#__PURE__*/_jsxs(Text, {
              variant: "body",
              children: ["Deleted ", vehiclesDeleted, " of ", vehicles?.length || 0, " vehicle(s)"]
            }), /*#__PURE__*/_jsxs(Text, {
              variant: "body",
              children: ["Deleted ", zonesDeleted, " of ", zones?.length || 0, " zone(s)"]
            })]
          })]
        })
      })
    }), /*#__PURE__*/_jsx(Content.Footer, {
      variant: "dialogFooter",
      layout: "flex:rowMEnd",
      children: /*#__PURE__*/_jsx(Button, {
        onClick: cancel,
        children: "Cancel Deletion"
      })
    })]
  });
}
export default Resetting;